import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import batchDispatch from '../../ReduxRequests/Dispatch/batchDispatch';
import userManagementDispatch from '../../ReduxRequests/Dispatch/userManagementDispatch';
import authState from '../../ReduxRequests/State/authState';
import batchState from '../../ReduxRequests/State/batchState';
import userManagementState from '../../ReduxRequests/State/userManagementState';
import BatchActionButtons from './BatchActionButtons';
import CloseButton from '../Custom/CloseButton';
import BatchDropZone from './BatchDropZone';
import BatchInputCodeTableView from './BatchInputCodeTableView';
import BatchLinearProgress from './BatchLinearProgress';
import BatchRecord from './BatchRecord';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import {saveAs} from 'file-saver';
import * as jsPDF from 'jspdf';
import * as JSZip from 'jszip';
import * as moment from 'moment';
import {
    BATCH_ERROR_MESSAGES,
    BATCH_STAGE,
    DATE_FORMAT,
    INVALID_RECORD_TYPE,
    itemsIgnored,
    TABLE_TYPE,
    updateActions
} from '../../Config/appConfig';
import {Auth, ActionCode, BatchFinalResult, BatchResult, BatchRow, InsurerCode, InsurerId} from '../../Config/dataModel';
import {assertTrue, clearErrors, throwErrorClient} from '../../Util/errorUtil';
import util from '../../Util/util';
import Modal from '../Modal/Modal';
import '../../style/batch.css';

const download = require('../../resource/img/download.svg');
const logo = require('../../resource/img/logo-medium.png');
const pageSpinner = require('../../resource/img/page-loading.gif');

const mapDispatchToProps = (dispatch) => {
    return {
        ...batchDispatch(dispatch),
        ...userManagementDispatch(dispatch)
    }
};

const mapStateToProps = (state) => {
    return {
        ...authState(state),
        ...batchState(state),
        ...userManagementState(state)
    }
};

interface BatchProps {
    auth: () => Auth,
    insurerId: () => InsurerId,
    isInsurer: () => boolean,
    registeredInsurers: InsurerCode[],
    actionCode: ActionCode[],
    fetchRegisteredInsurers: () => void,
    fetchActionCode: () => void,
    fetchTemplate: () => void,
    uploadResult: BatchResult[],
    finalUploadResult: BatchFinalResult[],
    uploadProgress: number,
    uploadBatch: (data: FormData) => void,
    uploadBatchFinal: (data: FormData) => void,
    template: Blob
}

interface BatchState {
    stage: string,
    insurers: InsurerCode[],
    actionCode: ActionCode[],
    file: any,
    finalResult: BatchFinalResult[],
    uploaded: number,
    validRecords: BatchRow[],
    overallError: string[],
    csvDuplicateError: BatchRow[],
    dltDuplicateError: BatchRow[],
    incompleteError: BatchRow[],
    incompleteErrorRows: number[],
    header: string,
    insurersFetched: boolean,
    actionCodeFetched: boolean,
    btnLoading: boolean,
    pageLoading: boolean,
    displayModal: boolean
}

class Batch extends React.Component <RouteComponentProps & BatchProps, BatchState> {
    public getTemplate: boolean = false;
    public uploadBatch: boolean = false;
    public hasErrors: boolean = false;

    public constructor(props: BatchProps) {
        super(props);
        this.state = {
            ...{
                insurers: [],
                actionCode: [],
                insurersFetched: false,
                actionCodeFetched: false
            }, ...this.getInitialState()
        };
        this.clickReset = this.clickReset.bind(this);
        this.clickSubmit = this.clickSubmit.bind(this);
        this.clickDownloadResult = this.clickDownloadResult.bind(this);
        this.clickClose = this.clickClose.bind(this);
        this.downloadTemplate = this.downloadTemplate.bind(this);
        this.onError = this.onError.bind(this);
    }

    public getInitialState() {
        return {
            stage: BATCH_STAGE.READY,
            file: null,
            finalResult: [],
            uploaded: 0,
            validRecords: [],
            overallError: [],
            csvDuplicateError: [],
            dltDuplicateError: [],
            incompleteError: [],
            incompleteErrorRows: [],
            header: '',
            btnLoading: false,
            pageLoading: false,
            displayModal: false
        };
    }

    public componentDidMount() {
        this.getInputCode();
    }

    public componentWillReceiveProps(nextProps: BatchProps) {
        if (nextProps.registeredInsurers !== this.props.registeredInsurers) {
            this.setState({
                insurers: nextProps.registeredInsurers,
                insurersFetched: true
            });
        }
        if (nextProps.actionCode !== this.props.actionCode) {
            this.setState({
                actionCode: nextProps.actionCode,
                actionCodeFetched: true
            });
        }
        if (nextProps.uploadResult !== this.props.uploadResult) { this.validate(nextProps.uploadResult); }
        if (nextProps.finalUploadResult !== this.props.finalUploadResult) {
            const failed = nextProps.finalUploadResult.filter((elem) => elem.status === 'FAILED');
            this.setBtnLoading(false);
            if (!assertTrue(183, failed.length === 0)) { return; }
            this.setState({
                stage: BATCH_STAGE.SUBMIT,
                finalResult: nextProps.finalUploadResult,
            });
        }
        if (this.uploadBatch && nextProps.uploadProgress) {
            this.setState({
                uploaded: nextProps.uploadProgress
            });
            if (nextProps.uploadProgress === 100) {
                setTimeout(() => {
                    if (!this.hasErrors) this.setPageLoading(true);
                }, 1000);
            }
        }
        if (this.getTemplate && nextProps.template) {
            this.getTemplate = false;
            this.saveTemplate(nextProps.template);
        }
    }

    public getInputCode() {
        this.props.fetchActionCode();
        if (this.props.isInsurer()) {
            this.setState({
                insurers: [{
                    shortId: this.props.auth().user.companyCode,
                    displayName: this.props.auth().user.company
                }]
            });
        }
        else this.props.fetchRegisteredInsurers();
    }

    public validate(data: BatchResult[]) {
        this.uploadBatch = false;
        this.setPageLoading(false);
        const reader = new FileReader();
        reader.onload = () => {
            const fileContent = (reader.result as string).split(/\r\n|\n/);
            for (let i = 0; i < data.length; i++) {
                if (data[i].error) {
                    if (data[i].rowNumber === 0) {
                        this.setState({
                            overallError: data[i].errorMsgs
                        });
                        continue;
                    }
                    try {
                        this.setError(data[i].rowNumber + 1, fileContent[data[i].rowNumber].split(','), data[i].errorMsgs);
                    } catch (error) {
                        throwErrorClient(181);
                    }
                }
            }
            if (this.state.csvDuplicateError.length
                || this.state.dltDuplicateError.length
                || this.state.incompleteError.length) {
                this.setState({
                    stage: BATCH_STAGE.INVALID
                });
            }
            else {
                try {
                    const records = [];
                    for (let i = 1; i < fileContent.length; i++) {
                        if (data[i]) {
                            records.push(this.getRecord(data[i].rowNumber + 1, fileContent[data[i].rowNumber].split(',')));
                        }
                    }
                    this.setState({
                        stage: BATCH_STAGE.VALID,
                        validRecords: records,
                        header: fileContent[0]
                    });
                } catch (error) {
                    throwErrorClient(182);
                }
            }
        };
        reader.readAsText(this.state.file);
    }

    public setError(idx: number, data: string[], errorMsgs: string[]) {
        const csvDuplicateError = this.state.csvDuplicateError;
        const dltDuplicateError = this.state.dltDuplicateError;
        const incompleteError = this.state.incompleteError;
        for (let i = 0; i < errorMsgs.length; i++) {
            if (errorMsgs[i] === INVALID_RECORD_TYPE.CSV_DUPLICATED) { csvDuplicateError.push(this.getRecord(idx, data, [BATCH_ERROR_MESSAGES.CSV_DUPLICATED])); }
            else if (errorMsgs[i] === INVALID_RECORD_TYPE.DLT_DUPLICATED) { dltDuplicateError.push(this.getRecord(idx, data, [BATCH_ERROR_MESSAGES.DLT_DUPLICATED])); }
            else if (this.state.incompleteErrorRows.indexOf(idx) === -1) {
                const newErrorMsgs = errorMsgs.slice();
                const csvDuplicateIdx = newErrorMsgs.indexOf(INVALID_RECORD_TYPE.CSV_DUPLICATED);
                if (csvDuplicateIdx !== -1) { newErrorMsgs.splice(csvDuplicateIdx, 1); }
                const dltDuplicateIdx = newErrorMsgs.indexOf(INVALID_RECORD_TYPE.DLT_DUPLICATED);
                if (dltDuplicateIdx !== -1) { newErrorMsgs.splice(dltDuplicateIdx, 1); }
                incompleteError.push(this.getRecord(idx, data, newErrorMsgs));
                const incompleteErrorRows = this.state.incompleteErrorRows;
                incompleteErrorRows.push(idx);
                this.setState({
                    incompleteErrorRows
                });
            }
        }
        this.setState({
            csvDuplicateError,
            dltDuplicateError,
            incompleteError
        });
    }

    public setDisplayModal(display: boolean) {
        this.setState({
            displayModal: display
        });
    }

    public setBtnLoading(btnLoading: boolean) {
        this.setState({btnLoading});
    }

    public setPageLoading(pageLoading: boolean) {
        this.setState({pageLoading});
    }

    public getRecord(idx: number, record: string[], errorMsgs?: string[]) {
        const data = [];
        for (let i = 0; i < record.length; i++) {
            data.push(record[i].replace(/"/g, ''));
        }
        return {
            row: idx,
            actionCode: data[0] || '',
            company: data[1] || '',
            identity: data[2] || '',
            identityNo: data[3] || '',
            chassisNo: data[4] || '',
            issueNo: data[5] || '',
            startDate: data[6] || '',
            endDate: data[7] || '',
            license: data[8] || '',
            newIssueNo: data[9] || '',
            newStartDate: data[10] || '',
            newEndDate: data[11] || '',
            newVoidDate: data[12] || '',
            newLicense: data[13] || '',
            errorMsgs: errorMsgs || []
        };
    }

    public getTitle() {
        if (this.props.isInsurer()) { return this.state.stage === BATCH_STAGE.SUBMIT ? `${this.state.validRecords.length} ${this.state.validRecords.length === 1 ? 'Record' : 'Records'} Successfully Submitted` : 'Batch Upload Cover Note / Policy'; }
        else { return this.state.stage === BATCH_STAGE.SUBMIT ? `${this.state.validRecords.length} Cover Note Successfully Submitted` : 'Batch Upload Cover Note'; }
    }

    public getBatchData(file: Blob) {
        const data = new FormData();
        data.append('file', file);
        data.append('insurerId', this.props.insurerId().insurerId);
        return data;
    }

    public getCompanyName(companyCode: string) {
        if (this.props.isInsurer()) return this.props.auth().user.company;
        else return this.props.auth().allCounterparties[companyCode].company;
    }

    public onDrop(file: any) {
        const csv = file[0];
        clearErrors();
        if (csv) {
            this.props.uploadBatch(this.getBatchData(csv));
            this.uploadBatch = true;
            this.setState({
                stage: BATCH_STAGE.CHECK,
                file: csv
            });
        }
        else throwErrorClient(180);
    }

    public clickReset() {
        clearErrors();
        this.setState(this.getInitialState());
        this.getTemplate = false;
    }

    public clickSubmit() {
        clearErrors();
        this.setBtnLoading(true);
        this.props.uploadBatchFinal(this.getBatchData(this.state.file));
    }

    public clickDownloadResult() {
        const zip = new JSZip();
        const fileName = `Batch_${moment().format(DATE_FORMAT.FILE_DATE)}`;
        const batchFiles = zip.folder(fileName);
        const pdfFiles = batchFiles.folder('PDF');
        const qrCodeFiles = batchFiles.folder('QRCode');
        let csvContent = `${this.state.header},Status\n`;
        for (let i = 0; i < this.state.finalResult.length; i++) {
            const pdf = new jsPDF();
            pdf.addImage(logo, 'PNG', 10, 10, 30, 11);
            pdf.setFontSize(14).setTextColor(90, 90, 90).text(162, 16, 'Record Summary');
            pdf.setDrawColor(238, 238, 238).setLineWidth(0.5).line(0, 27, 210, 27);
            pdf.setDrawColor(168, 183, 199).setLineWidth(0.3);
            let height = 42.4;
            for (let j = 0; j < 11; j++) {
                pdf.line(25, height, 185, height);
                height += 14.6;
            }
            const data = this.state.finalResult[i];
            const status = data.midasStatus;
            const row = data.rowNumber - 1;
            const record = this.state.validRecords[row];
            let issueNo = record.issueNo;
            let license = record.license;
            let startDate = record.startDate;
            let endDate = record.endDate;
            if (updateActions.indexOf(record.actionCode) !== -1) {
                issueNo = record.newIssueNo === "" ? record.issueNo : record.newIssueNo;
                license = record.newLicense === "" ? record.newLicense : record.newLicense;
                startDate = record.newStartDate === "" ? record.startDate : record.newStartDate;
                endDate = record.newEndDate === "" ? record.endDate : record.newEndDate;
            }
            const coverPeriod = util.getDuration(util.getDate(startDate), util.getDate(endDate)).toString();
            const content =
                'Midas Number\n' + data.midasRef + '\n\n' +
                'Cover Note Number\n' + issueNo + '\n\n' +
                'Identity Number\n' + util.getCsvIdentity(record.identity, record.identityNo) + '\n\n' +
                'Chassis Number\n' + record.chassisNo + '\n\n' +
                'License Plate Number (Optional)\n' + util.getLicense(license) + '\n\n' +
                'Insurance Company\n' + this.getCompanyName(record.company) + '\n\n' +
                'Coverage Period (days)\n' + coverPeriod + '\n\n' +
                'Start Date\n' + util.getFormattedDatetime(startDate) + '\n\n' +
                'End Date\n' + util.getFormattedDatetime(endDate) + '\n\n' +
                'Policy Type\n' + util.getPolicyType(data.policyType) + '\n\n' +
                'Status\n' + util.getFlowStatus(false, status, false) + '\n\n';
            pdf.setFontSize(12).text(30, 34, pdf.splitTextToSize(content, 150));
            try {
                pdf.addImage(`data:image/png;base64,${data.qrCode}`, 'PNG', 75, 205, 60, 60);
            } catch (error) {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    const imgData = canvas.toDataURL('image/jpeg');
                    pdf.addImage(imgData, 'JPEG', 75, 205, 60, 60);
                };
                img.src = `data:image/png;base64,${data.qrCode}`;
            }
            const filename = issueNo.replace((/[\/\\]/g), "_");
            pdfFiles.file(`${filename}.pdf`, pdf.output('blob'));
            qrCodeFiles.file(`${filename}.png`, data.qrCode, {base64: true});
            for (const item in record) {
                if (itemsIgnored.indexOf(item) === -1) { csvContent += `${record[item]},`; }
            }
            csvContent += `${util.getFlowStatus(false, status, false)}\n`;
        }
        batchFiles.file(`${fileName}.csv`, csvContent);
        zip.generateAsync({type: 'blob'}).then((blob) => {
            const zipFileName = `${fileName}.zip`;
            try {
                saveAs(blob, zipFileName);
            } catch (error) {
                window.navigator.msSaveBlob(blob, zipFileName);
            }
        });
    }

    public clickClose(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.state.stage === BATCH_STAGE.SUBMIT ? this.setDisplayModal(true) : this.leave();
    }

    public downloadTemplate() {
        clearErrors();
        this.getTemplate = true;
        this.props.fetchTemplate();
    }

    public saveTemplate(data: Blob) {
        const blob = new Blob([data]);
        saveAs(blob, 'template.csv');
    }

    public onError() {
        this.hasErrors = true;
        this.setBtnLoading(false);
        this.setPageLoading(false);
    }

    public getErrorMsg() {
        const errorMsgs = [];
        for (let i = 0; i < this.state.overallError.length; i++) {
            errorMsgs.push(
                <div key={i} className="batchErrorMsg">{this.state.overallError[i]}</div>
            );
        }
        return errorMsgs;
    }

    public getModalContent() {
        return (<div className="cmText modalText modalTextSm">Submission records cannot be downloaded after leaving this page, are you sure you want to leave?</div>);
    }

    public handleModal(event: React.MouseEvent<HTMLElement>, leave: boolean) {
        event.preventDefault();
        this.setDisplayModal(false);
        if (leave) this.leave();
    }

    public leave() {
        if (this.props.location.state && this.props.location.state.fromDashboard) this.props.history.goBack();
        else this.props.history.push(util.getDest(this.props.history.location.pathname.split('/')[2]));
    }

    public render() {
        let closeButtonExtraProps = {};
        if (this.props.location.state && this.props.location.state.fromDashboard) {
            closeButtonExtraProps = {...closeButtonExtraProps, ...{goBack: true}};
        }
        return (
            <div className="cmHorCenter cmFormContainer">
                <div>
                    <div className="cmFormTitleHeader">
                        <div className="cmFormTitle">{this.getTitle()}</div>
                        <CloseButton clickClose={this.clickClose} {...closeButtonExtraProps}/>
                    </div>
                    {this.state.stage === BATCH_STAGE.SUBMIT ?
                        <div>
                            <div className="cmInput batchFileContainer">
                                <div className="cmText cmVerCenter batchTemplate">Download submission records</div>
                                <button onClick={this.clickDownloadResult}><img src={download}/></button>
                            </div>
                        </div> :
                        <div>
                            <div>
                                <div>
                                    <div className="cmInput batchFileContainer">
                                        <div className="cmText cmVerCenter batchTemplate">Download Template</div>
                                        <button onClick={this.downloadTemplate}>
                                            <img src={download}/>
                                        </button>
                                    </div>
                                    {this.state.stage === BATCH_STAGE.READY ?
                                        <BatchDropZone
                                            fileName={this.state.file ? this.state.file.name : 'Upload File'}
                                            onDrop={(file) => this.onDrop(file)}/> :
                                        <BatchLinearProgress
                                            fileName={this.state.file.name}
                                            uploaded={this.state.uploaded}
                                            clickRemove={this.clickReset}/>}
                                </div>
                                {this.state.overallError.length ?
                                    this.getErrorMsg() :
                                    <div>
                                        <ErrorHandler onError={this.onError}/>
                                        {(this.state.stage === BATCH_STAGE.VALID || this.state.stage === BATCH_STAGE.INVALID) &&
                                        <BatchRecord
                                            stage={this.state.stage}
                                            validRecords={this.state.validRecords}
                                            csvDuplicateError={this.state.csvDuplicateError}
                                            dltDuplicateError={this.state.dltDuplicateError}
                                            incompleteError={this.state.incompleteError}/>}
                                    </div>}
                                {this.state.stage === BATCH_STAGE.CHECK && this.state.pageLoading &&
                                <div className="cmHorCenter batchReadingSpinner">
                                    <img className="cmHorCenter" src={pageSpinner}/>
                                    <div>Checking. Please wait...</div>
                                </div>}
                            </div>
                            <div>
                                <BatchActionButtons
                                    stage={this.state.stage}
                                    clickClose={this.clickClose}
                                    clickReset={this.clickReset}
                                    clickSubmit={this.clickSubmit}
                                    loading={this.state.btnLoading}/>
                            </div>
                            {this.state.stage === BATCH_STAGE.READY &&
                            <div className="batchInputCode">
                                <div className="cmText batchInputCodeTitle">CSV Input Code</div>
                                {(this.props.isInsurer() ? this.state.actionCodeFetched : this.state.actionCodeFetched && this.state.insurersFetched) ?
                                    <div>
                                        <BatchInputCodeTableView
                                            tableType={TABLE_TYPE.INSURANCE}
                                            list={this.state.insurers}/>
                                        <BatchInputCodeTableView
                                            tableType={TABLE_TYPE.ACTION}
                                            list={this.state.actionCode}/>
                                    </div> :
                                    <img className="cmHorCenter" src={pageSpinner}/>}
                            </div>}
                        </div>}
                </div>
                {this.state.displayModal &&
                <Modal
                    content={this.getModalContent()}
                    leftBtn="Cancel"
                    rightBtn="Proceed"
                    clickCancel={(e) => this.handleModal(e, false)}
                    clickConfirm={(e) => this.handleModal(e, true)}/>}
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Batch));



// WEBPACK FOOTER //
// ./src/Components/Batch/Batch.tsx